import React, { useState } from "react";
import Input from "../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import { fieldTypeOptions, isNamePresent } from "./util";

const Field = ({ field, onDelete, onEdit, config }) => {
  const [editMode, setEditMode] = useState(false);
  const [editedField, setEditedField] = useState({ ...field });
  const [nameError, setNameError] = useState("");
  const [indexError, setIndexError] = useState("");

  const handleEdit = () => {
    setEditMode(true);
    setEditedField({ ...field });
    setNameError("");
    setIndexError("");
  };

  const handleSave = () => {
    const trimmedName = editedField.name.trim();
    const existingField = field.name === trimmedName ? null : isNamePresent(config, trimmedName);

    if (trimmedName === "") {
      setNameError("Name cannot be empty!");
      return;
    }

    if (existingField) {
      setNameError(`Field with name "${trimmedName}" already exists!`);
      return;
    }

    if (editedField.type === "fk") {
      const { f_table, instance_id, pk } = editedField.index;
      if (!f_table || !instance_id || !pk) {
        setIndexError("Please fill all index fields for Foreign Key type!");
        return;
      }
    }

    onEdit(field.name, editedField);
    setEditMode(false);
    setNameError("");
    setIndexError("");
  };

  const handleCancel = () => {
    setEditMode(false);
    setNameError("");
    setIndexError("");
  };

  const handleFieldChange = (name, value) => {
    setEditedField({ ...editedField, [name]: value });
    setNameError("");
    setIndexError("");
  };

  const handleIndexChange = (e) => {
    const { name, value } = e.target;
    setEditedField({
      ...editedField,
      index: {
        ...editedField.index,
        [name]: value
      }
    });
    setIndexError("");
  };

  const handleAddSubField = () => {
    const randomName = `Field_${Math.floor(Math.random() * 1000)}`;
    const newSubField = { name: randomName, type: "int", index: null, sub_fields: null };

    onEdit(field.name, {
      ...field,
      sub_fields: [...field.sub_fields, newSubField]
    });
  };

  const renderIndexInfo = () => {
    if (editedField.type === "fk") {
      return (
        <div>
          {editMode ? (
            <>
              <Input
                label="F Table:"
                id="f_table"
                name="f_table"
                value={editedField.index?.f_table || ""}
                onChange={handleIndexChange}
              />
              <br />
              <Input
                label="Instance ID:"
                id="instance_id"
                name="instance_id"
                value={editedField.index?.instance_id || ""}
                onChange={handleIndexChange}
              />
              <br />
              <Input
                label="PK:"
                type="text"
                id="pk"
                name="pk"
                value={editedField.index?.pk || ""}
                onChange={handleIndexChange}
              />
              <br />
              {indexError && <span style={{ color: "red", fontSize: "12px" }}>{indexError}</span>}
            </>
          ) : (
            <div>
              <div
                style={{
                  borderBottom: "1px solid var(--builder-border)",
                  padding: "2px 5px",
                  marginBottom: "2px",
                  display: "block"
                }}
              >
                F Table: {field.index?.f_table}
              </div>
              <div
                style={{
                  borderBottom: "1px solid var(--builder-border)",
                  padding: "2px 5px",
                  marginBottom: "2px",
                  display: "block"
                }}
              >
                Instance ID: {field.index?.instance_id}
              </div>
              <div style={{ borderBottom: "1px solid var(--builder-border)", padding: "2px 5px", display: "block" }}>
                PK: {field.index?.pk}
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return "-";
    }
  };

  return (
    <tr>
      <td style={{ /* border: "1px solid black"*/ border: "1px solid var(--builder-border)", padding: "8px" }}>
        {editMode ? (
          <>
            <Input
              name="name"
              value={editedField.name}
              onChange={(e) => handleFieldChange(e.target.name, e.target.value)}
            />
            <br />
            {nameError && <span style={{ color: "red", fontSize: "12px" }}>{nameError}</span>}
          </>
        ) : (
          field.name
        )}
      </td>
      <td style={{ /*border: "1px solid black"*/ border: "1px solid var(--builder-border)", padding: "8px" }}>
        {editMode ? (
          <>
            <SingleSelectBox
              selectedData={editedField.type}
              options={fieldTypeOptions}
              onChange={(obj) => handleFieldChange("type", obj.id)}
              placeholder="Select Type"
            />
          </>
        ) : (
          field.type
        )}
      </td>
      <td style={{ border: "1px solid var(--builder-border)", padding: "8px" }}>{renderIndexInfo()}</td>
      <td
        style={{
          display: "flex",
          gap: "4px",
          borderTop: "1px solid var(--builder-border)",
          padding: "8px",
          alignItems: "center"
        }}
      >
        {editMode ? (
          <>
            <ButtonActionIcon type="save" onClick={handleSave} />
            <ButtonActionIcon type="close" onClick={handleCancel} />
          </>
        ) : (
          <>
            {field.type === "recordset-list" && <ButtonActionIcon type="add" onClick={handleAddSubField} />}
            <ButtonActionIcon type="edit" onClick={handleEdit} />
            <ButtonActionIcon type="delete" onClick={() => onDelete(field.name)} />
          </>
        )}
      </td>
    </tr>
  );
};

export default Field;
